import React, { FC, HTMLAttributes } from 'react'

import { Typography } from '@smarty-nx/ds'
import cn from 'classnames'

import classes from './quote.module.scss'
import Mark from '../../static/images/QuotationMark.svg'
import MarkAlt from '../../static/images/QuotationMarkAlt.svg'

interface QuoteProps extends HTMLAttributes<HTMLDivElement> {
  text: string
  source?: string
  useAltQuoteMark?: boolean
  hideQuoteMark?: boolean
}

const Quote: FC<QuoteProps> = ({
  text,
  source,
  useAltQuoteMark = false,
  hideQuoteMark = false,
  className,
  ...props
}) => {
  if (!text) return null

  return (
    <div className={cn(classes.root, className)} {...props}>
      {!hideQuoteMark && (
        <img
          className={classes.quoteMark}
          src={useAltQuoteMark ? MarkAlt : Mark}
          alt=""
          loading="lazy"
          decoding="async"
        />
      )}
      <blockquote className={classes.blockQuote}>{text}</blockquote>
      {source && (
        <Typography variant="Montserrat/Medium" className={classes.source}>
          {source}
        </Typography>
      )}
    </div>
  )
}

export default Quote
